@if (!mainSolution && !isRideSharingEnabled) {
    <div class="solution-changes">
        @for (change of filteredDeltaConfigurations; track change; let last = $last) {
            <div>
                <span>{{ change.optimizationConfigurationName | translate }}</span>
                <span class="mx-1 icon-arrow-right"></span>
                <span [ngClass]="{ 'pr-2': !last }"><b [translate]="change.value"></b></span>
                @if (change.optimizationConfigurationNameSecondPart) {
                    <span>&nbsp;{{ change.optimizationConfigurationNameSecondPart | translate }}</span>
                }
            </div>
        }
    </div>
}
@if (isRideSharingEnabled && objectiveWeights$ | async; as objectiveWeights) {
    <div
        class="optimization-header-objective-weights mb-2"
    >
        @if (objectiveWeights.timeWindowWeight) {
            <span>
                {{ 'LATE_ARRIVALS' | translate }}: <b>{{ objectiveWeights.timeWindowWeight | translate }} </b>
            </span>
        }
        @if (objectiveWeights.travelTimeWeight) {
            <span>
                {{ 'TRAVEL_TIME' | translate }}: <b>{{ objectiveWeights.travelTimeWeight | translate }} </b>
            </span>
        }
        @if (objectiveWeights.visitHistoryWeight) {
            <span>
                {{ 'VISIT_CONTINUITY' | translate }}: <b>{{ objectiveWeights.visitHistoryWeight | translate }} </b>
            </span>
        }
        @if (objectiveWeights.overqualifiedWeight) {
            <span>
                {{ 'OVERQUALIFICATION' | translate }}: <b>{{ objectiveWeights.overqualifiedWeight | translate }}</b>
            </span>
        }
    </div>
}
<div class="solution-container" [ngClass]="{'solution-margin': filteredDeltaConfigurations?.length > 0}">
    <div class="solution-content">
        <div class="d-flex justify-content-between w-100 m-auto solution-content-container py-2">
            <app-tooltip
                appCustomPopover
                popoverText="LATE_ARRIVALS_OBJECTIVE_INFO"
                placement="right"
            >
                <ng-container icon>
                    <app-route-key-number
                        translation='LATE_ARRIVALS'
                        [compareValue]="totalKeyNumbers ? totalKeyNumbers.totalTimeBreakingTimeWindowsInSeconds : undefined"
                        timeValue="true"
                    >
                        <ng-container content>
                            <span>{{ routeKeyNumberWeights.accurateArrivals[0] }}</span>{{ "HOURS_SHORT" | translate }}&nbsp;
                            <span>{{ routeKeyNumberWeights.accurateArrivals[1] }}</span>{{ "MINUTES_SHORT" | translate }}
                        </ng-container>
                    </app-route-key-number>
                </ng-container>
            </app-tooltip>
            <app-tooltip
                appCustomPopover
                [popoverText]="transportTooltip"
                placement="top"
            >
                <ng-container icon>
                    @if (transportTravelTime) {
                        <app-route-key-number
                            translation='TRAVEL_TIME'
                            [compareValue]="totalKeyNumbers ? totalKeyNumbers.totalTravelTimeSeconds : undefined"
                            timeValue="true"
                        >
                            <ng-container content>
                                <span>{{ routeKeyNumberWeights.travelTime[0] }}</span>{{ "HOURS_SHORT" | translate }}&nbsp;
                                <span>{{ routeKeyNumberWeights.travelTime[1] }}</span>{{ "MINUTES_SHORT" | translate }}
                            </ng-container>
                        </app-route-key-number>
                    }
                </ng-container>
            </app-tooltip>
            <app-tooltip
                appCustomPopover
                popoverText="VISIT_CONTINUITY_OBJECTIVE_INFO"
                [popoverTextParam]="String(routeKeyNumberWeights.visitContinuity)"
                placement="top"
            >
                <ng-container icon>
                    <app-route-key-number
                        translation='VISIT_CONTINUITY'
                        [compareValue]="totalKeyNumbers ? routeKeyNumberWeights.visitContinuity : undefined"
                    >
                        <ng-container content>
                            <span>{{ routeKeyNumberWeights.visitContinuity }}</span>
                            &nbsp;{{ "X_NEW_VISITS" | translate }}
                        </ng-container>
                    </app-route-key-number>
                </ng-container>
            </app-tooltip>
            <app-tooltip
                appCustomPopover
                popoverText="ABOVE_MAX_VISIT_CONTINUITY_OBJECTIVE_INFO"
                placement="top"
            >
                <ng-container icon>
                    @if (routeKeyNumberWeights.overMaxEmployeeCount) {
                        <app-route-key-number
                            translation="ABOVE_MAX"
                            [compareValue]="totalKeyNumbers ? routeKeyNumberWeights.overMaxEmployeeCount : undefined"
                        >
                            <ng-container content>
                                <span>{{ routeKeyNumberWeights.overMaxEmployeeCount }}</span>
                                &nbsp;{{ "VISITS" | translate }}
                            </ng-container>
                        </app-route-key-number>
                    }
                </ng-container>
            </app-tooltip>
            <app-tooltip
                appCustomPopover
                popoverText="OVERQUALIFICATION_OBJECTIVE_INFO"
                placement="top"
            >
                <ng-container icon>
                    <app-route-key-number
                        translation='OVERQUALIFICATION'
                        [compareValue]="totalKeyNumbers ? routeKeyNumberWeights.correctCompetence : undefined"
                    >
                        <ng-container content>
                            <span>{{ routeKeyNumberWeights.correctCompetence }}</span> &nbsp;{{ "VISITS" | translate }}
                        </ng-container>
                    </app-route-key-number>
                </ng-container>
            </app-tooltip>
            <app-tooltip
                appCustomPopover
                popoverText="DIFFERENT_ROSTER_DEPARTMENT_OBJECTIVE_INFO"
                placement="top"
            >
                <ng-container icon>
                    @if (rosterInInstance) {
                        <app-route-key-number
                            translation="DIFFERENT_ROSTER_DEPARTMENT"
                            [compareValue]="routeKeyNumberWeights.differentRosterTasks"
                        >
                            <ng-container content>
                                <span>{{ routeKeyNumberWeights.differentRosterTasks }}</span>
                                &nbsp;{{ "PROGRESS_DIFFERENT_DEPARTMENT" | translate }}
                            </ng-container>
                        </app-route-key-number>
                    }
                </ng-container>
            </app-tooltip>
            <app-tooltip
                appCustomPopover
                popoverText="UNALLOCATED_TOOLTIP_INFO"
                placement="top"
            >
                <ng-container icon>
                    @if (routeKeyNumberWeights.unallocatedTasks !== null) {
                        <app-route-key-number
                            translation="UNALLOCATED_EMPLOYEE_TASKS"
                            [compareValue]="totalKeyNumbers ? routeKeyNumberWeights.unallocatedTasks : undefined"
                        >
                            <ng-container content>
                                <span>{{ routeKeyNumberWeights.unallocatedTasks }}</span>
                                &nbsp;{{ "PROGRESS_UNALLOCATED" | translate }}
                            </ng-container>
                        </app-route-key-number>
                    }
                    @if (routeKeyNumberWeights.unallocatedTasksPatients !== null) {
                        <app-route-key-number
                            translation="UNALLOCATED_PATIENT_TASKS"
                            [compareValue]="totalKeyNumbers ? routeKeyNumberWeights.unallocatedTasksPatients : undefined"
                        >
                            <ng-container content>
                                <span>{{ routeKeyNumberWeights.unallocatedTasksPatients }}</span>
                                &nbsp;{{ "PROGRESS_UNALLOCATED" | translate }}
                            </ng-container>
                        </app-route-key-number>
                    }
                </ng-container>
            </app-tooltip>
        </div>
        <button
            type="button"
            class="btn btn-primary right m-0"
            [disabled]="!totalKeyNumbers || !(convergenceLikeliness === 1 || timeLeft === 0)"
            (click)="select()"
        >
            {{ "CHOOSE_ROUTE_BTN" | translate }}
        </button>
    </div>
    @if (timeLeft > 0) {
        <div class="solution-progress" [@fadeInOnEnter] [@fadeOutOnLeave]>
            <app-progress-bar [value]="progress" [timeLeft]="timeLeft"></app-progress-bar>
        </div>
    }
</div>
@if (mainSolution && isRideSharingEnabled) {
    <p class="solution-margin mt-3" id="best-solution-hint">
        {{ 'RIDE_SHARING_SOLUTION_HINT' | translate }}
    </p>
}

